import React from 'react';

const EditProduct = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Edit Product</h1>
      <p className="text-gray-600">Update product information.</p>
    </div>
  );
};

export default EditProduct;
